module.exports = __webpack_public_path__ + "img/icon-flag-united-states.05697a2f.png";